// extracted by mini-css-extract-plugin
module.exports = {"root":"PullQuoteBlock-module--root--2Pi2f utilities-module--kaleidoscopeBox--2xBE5","text":"PullQuoteBlock-module--text--1Lfn_"};